module.exports = require("@git-stack/microservice-nats");